// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y0kN","tabsBox":"styles_tabsBox__1jOqP","createButton":"styles_createButton__30h2c"};